import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { FormLink } from '../ContactForm';
import { PasswordForgetLink } from '../PasswordForget';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import { Link } from 'react-router-dom';

import './styles.css'

const SignInPage = () => (
  <div id = 'signin-content'>
    <Link to={ROUTES.LANDING}> <img onClick = {() => {document.title = 'HyprView'}} id = "logo-signin" src = {"https://hyprview-landing-images.s3.eu-west-3.amazonaws.com/logo_hyprview_thin_black.png"}/></Link>
    <div id = 'signin'>
      <SignInForm />
      {/* <PasswordForgetLink /> */}
      <FormLink />
    </div>
  </div>
);

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    document.title = 'Signin'
  }
  onSubmit = event => {
    const { email, password } = this.state;

    this.props.firebase
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.HOME);
      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, password, error } = this.state;

    const isInvalid = password === '' || email === '';

    return (
      <form id = "signin-form" onSubmit={this.onSubmit}>
        <input
          id = 'signin-input'
          name="email"
          value={email}
          onChange={this.onChange}
          type="text"
          placeholder="Email"
        />
        <input
          id = 'signin-password-input'
          name="password"
          value={password}
          onChange={this.onChange}
          type="password"
          placeholder="Password"
        />
        <button disabled={isInvalid} type="submit">
          Sign in
        </button>
        <div id = 'signin-error'>
          {error && <p>{error.message}</p>}
        </div>
      </form>
    );
  }
}

const SignInForm = compose(
  withRouter,
  withFirebase,
)(SignInFormBase);

export default SignInPage;

export { SignInForm };
